import topBanner from 'src/assets/images/antiscam/visual_img_ok.jpg';
import contentTopImg from 'src/assets/images/antiscam/img_01.png';
import contentBottomImg from 'src/assets/images/antiscam/img_02.png';
import Banner from 'src/components/common/Banner';
import { useRecoilValue } from 'recoil';
import { UserAgentState } from 'src/recoil/common';
import PCContent from 'src/components/complete/PCContent';
import MobileContent from 'src/components/complete/MobileContent';
import styled from 'styled-components';
import Bottom from 'src/components/complete/Bottom';
import Modal from 'src/components/common/Modal';
import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'src/components/common/Button';
import { getCompleteMessage } from 'src/pages/complete/constant';
import Footer from 'src/components/common/Footer';

const ServiceConnectorWrap = styled.div`
  text-align: center;
  font-size: 14px;
`;

const ContentImageWrap = styled.div`
  border: 2px solid #b7bfcc;
  padding: 10px;
`;

const TextWrap = styled.div`
  padding: 20px 0;
`;

// const CompleteFooter = (
//   <ul>
//     <li>· 본 서비스는 SKT, KT, LG U+와 제휴하여 (주)데이터유니버스가 운영합니다.</li>
//     <li>· 고객센터(이용/해지) : 1811-7531 (공휴일 휴무 09:00 ~ 12:00 / 13:00 ~ 18:00)</li>
//   </ul>
// );

// const FooterStyle: FooterStyleProps = {
//   color: '#ffffff',
//   backgroundColor: 'black',
//   textAlign: 'left',
// };

const CompleteModalWrap = styled.div`
  width: 100%;
  text-align: center;
`;

const CompleteTop = styled.div`
  padding: 10px 0;
  font-size: 15px;
  color: #fff;
  background-color: #1c3d7d;
`;

const CompleteTitle = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #000;
  padding: 30px 3% 10px;
  word-break: keep-all;
`;

const ButtonWrap = styled.div`
  padding: 0 50px;
  line-height: 30px;
`;

const DescriptionWrap = styled.div`
  font-size: 14px;
  padding: 10px 0 20px;
`;

const Description = styled.span`
  color: #019ddf;
`;

const Complete = () => {
  const { jobStatus } = useParams();
  const userAgent = useRecoilValue(UserAgentState);
  const [completeModal, setCompleteModal] = useState<boolean>(true);
  const modalRef = useRef<HTMLDivElement>(null);

  const modalOutsideOnClick = (e: any) => {
    if (modalRef.current === e.target) {
      setCompleteModal(false);
    }
  };

  const handleOnClick = () => {
    setCompleteModal(false);
    const newWindow = window.open('http://s.antiscam.co.kr', '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  const CompleteModal = (
    <CompleteModalWrap>
      <CompleteTop>스마트피싱보호 서비스</CompleteTop>
      <CompleteTitle dangerouslySetInnerHTML={{ __html: getCompleteMessage(jobStatus) }} />
      <DescriptionWrap>
        <span>
          최신, 주요 사기정보 알림을 통해
          <br />
          진화하는 금융사기로부터
          <br />
          안전하게 예방하실 수 있습니다.
        </span>
      </DescriptionWrap>
      <ButtonWrap>
        <Button
          text="확인"
          onClick={handleOnClick}
          styles={{
            fontColor: '#fff',
            backgroundColor: '#019ddf',
            fontSize: '14px',
            height: '30px',
          }}
        />
      </ButtonWrap>
      <DescriptionWrap>
        <Description>
          '확인'버튼을 누르면
          <br />
          앱스토어로 이동합니다.
        </Description>
      </DescriptionWrap>
    </CompleteModalWrap>
  );

  return (
    <>
      {completeModal && (
        <Modal
          ref={modalRef}
          onClick={modalOutsideOnClick}
          styles={{ height: 'auto', width: '300px' }}
        >
          {CompleteModal}
        </Modal>
      )}
      <ServiceConnectorWrap>
        <Banner img={topBanner} />
        <TextWrap>
          {userAgent === 'PCWEB' && <PCContent />}
          {userAgent === 'MOBILEWEB' && <MobileContent />}
        </TextWrap>
        <ContentImageWrap>
          <Banner img={contentTopImg} />
          <Banner img={contentBottomImg} />
        </ContentImageWrap>
        <Bottom />
        <Footer />
      </ServiceConnectorWrap>
    </>
  );
};

export default Complete;
